var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1277_11883",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1277_11883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0781 18.4688H12.9218M16.62 18.4688H18.4638M5.54686 18.4688H7.39059M11.0781 12.9375H12.9218M16.62 12.9375H18.4638M5.54686 12.9375H7.39059M0.9375 8.31249H23.0731M17.5419 5.54686V0.937502M6.46875 5.54686V0.937502M4.63566 23.0625H19.375C21.4174 23.0625 23.0731 21.4068 23.0731 19.3643V6.47944C23.0731 4.437 21.4174 2.78124 19.375 2.78124H4.63566C2.59322 2.78124 0.9375 4.437 0.9375 6.47944V19.3643C0.9375 21.4068 2.59322 23.0625 4.63566 23.0625Z",
    stroke: "#0E6F1E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.2c5625117f6f9b8174d9d91c88d3a2c9.svg";
export { ForwardRef as ReactComponent };